import { UrlMatcher } from "@angular/router";

export function oneOf(...prefixes: string[]): UrlMatcher {
    return (segments) =>
        prefixes.some(prefix => segments[0]?.path === prefix) ?
            { consumed: segments.slice(0, 1) } :
            null;
}
